import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InputModule } from '../inputs/input.module';
import { EmailComponent } from './components/email.component';

@NgModule({
    imports: [
        CommonModule,

        InputModule,
    ],
    declarations: [
        EmailComponent,
    ],
    exports: [
        EmailComponent,
    ],
})

export class EmailModule {}
